module.exports = __webpack_public_path__ + "img/counter.2266116c.png";